class MemberDesc extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.member-desc__view-more');
    this.btnLabel = this.btn?.querySelector('.view-more-label');
    this.descEl = this.querySelector('.member-desc__description-wrapper');
  }

  connectedCallback() {
    const maxHeight = parseInt(this.descEl.style.maxHeight.replace('px', ''));
    const elHeight =
      this.descEl.querySelector('p:last-child').getBoundingClientRect().bottom -
      this.descEl.getBoundingClientRect().top;
    if (elHeight < maxHeight) {
      return;
    }
    this.descEl.classList.add('overflow');
    this.btn.classList.remove('hidden');
    this.btn.addEventListener('click', () => {
      if (this.descEl.classList.contains('open')) {
        this.descEl.style.maxHeight = maxHeight.toString() + 'px';
        this.btnLabel.textContent = 'もっと見る';
        this.btn.setAttribute('aria-expanded', 'false');
      } else {
        this.descEl.style.maxHeight = Math.ceil(elHeight).toString() + 'px';
        this.btnLabel.textContent = '折りたたむ';
        this.btn.setAttribute('aria-expanded', 'true');
      }
      this.descEl.classList.toggle('open');
    });
  }
}

customElements.define('member-desc', MemberDesc);
